export const LOGIN = "LOGIN";
export const SALES_USER = "SALES_USER";

export const GetToken = () => {
  const token = JSON.parse(localStorage.getItem(LOGIN));
  return token?.idToken ?? false;
};
